import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CPPolicyService } from 'src/app/corporate-portal/services/cp-policy.service';
import { Policy } from 'src/app/cp-member/models/policy.model';
import { SelfMember } from 'src/app/cp-member/models/self-member.model';
import { CPMemberService } from 'src/app/cp-member/services/CPMember.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { TrackingService } from 'src/app/Tracking.service';

@Component({
  selector: 'app-manage-profile',
  templateUrl: './manage-profile.component.html',
  styleUrls: ['./manage-profile.component.scss'],
})
export class ManageProfileComponent implements OnInit {
  currentPolicy: Policy;
  policies = [];
  isHr: boolean;
  isMember: boolean;
  isHrView: boolean;
  memberSelf: SelfMember;
  isMemberSelfLoaded = false;
  family;
  isEmployeeBelongsToPolicy = false;
  isLoading = true;
  constructor(
    private readonly router: Router,
    private policyService: CPPolicyService,
    private cpMemberService: CPMemberService,
    private location: Location,
    private authService: AuthService,
    private tracking: TrackingService
  ) {}

  ngOnInit() {
    this.memberSelf = new SelfMember();
    this.policyService.policies.subscribe(policies => {
      this.policies = policies;
    });

    this.cpMemberService.isHrView.subscribe(x => {
      this.isHrView = x;
      if (this.isHrView) {
        this.router.navigate(['/cp-member/profile']);
      }
    });
    this.isLoading = true;
    this.policyService.currentPolicy.subscribe(async (policy: any) => {
      this.currentPolicy = policy;
      this.isEmployeeBelongsToPolicy = this.currentPolicy.isMemberEnrolled;
      this.isHr = this.cpMemberService.isHr;
      this.isMember = this.cpMemberService.isMember;
      if (this.currentPolicy.policyNumber) {
        await this.cpMemberService
          .getMemberFamily(this.currentPolicy.policyNumber)
          .then(x => {
            console.log(x);
            this.family = x;
            this.isLoading = false;
          })
          .catch(x => {
            console.log('error');
            this.isLoading = false;
          });
      }

      if (policy.policyNumber !== undefined && this.isMember === true && this.currentPolicy.isMemberEnrolled) {
        this.cpMemberService.selfMemberDetails.subscribe(m => {
          this.memberSelf = m;
          this.isMemberSelfLoaded = true;
        });
      }
    });
  }

  onNamePolicyChanged(policy) {
    this.policyService.currentPolicy.next(policy);
  }


  goBack() {
    this.location.back();
  }

  async signout() {
    this.tracking.pushEvent("profile_logout", {});
    await this.authService.signout();
  }
}
